import { render, staticRenderFns } from "./industryService.vue?vue&type=template&id=6d5d6dd2&scoped=true&"
import script from "./industryService.vue?vue&type=script&lang=js&"
export * from "./industryService.vue?vue&type=script&lang=js&"
import style0 from "./industryService.vue?vue&type=style&index=0&id=6d5d6dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d6dd2",
  null
  
)

export default component.exports